export default {
      id: "instrum-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#instrum-usage",
      toString: function () {
        return this.url;
      }
    }